import {Box, Text} from '@yandex-delivery/blocks'
import {memo} from 'react'

import {renderWidget} from '../index'
import type {SlotWidgetBody} from '../types'
import * as styles from './SlotBody.classes'

/** Пропсы компонента SlotBody */
type SlotBodyProps = {
  /** Содержимое блока */
  body: SlotWidgetBody
}

/** Мапа из align конфига в justify-content из CSS */
const ALIGN_TO_JUSTIFY_CONTENT_MAP: Record<SlotWidgetBody['align'], 'left' | 'center' | 'right'> = {
  leading: 'left',
  center: 'center',
  trailing: 'right',
}

/**
 * Текстовый блок в слоте
 */
export const SlotBody = memo<SlotBodyProps>(function SlotBody({body}) {
  return (
    <Box className={styles.box} flexDirection="column" justifyContent={ALIGN_TO_JUSTIFY_CONTENT_MAP[body.align]}>
      {body.title && (
        <Text align={ALIGN_TO_JUSTIFY_CONTENT_MAP[body.align]} className={styles.text}>
          {body.title.items.map(renderWidget)}
        </Text>
      )}
      {body.subtitle && <Text className={styles.text}>{body.subtitle.items.map(renderWidget)}</Text>}
    </Box>
  )
})
